import React, { useEffect, useState } from 'react';
import { usePaystackPayment } from "react-paystack";
import { useParams } from 'react-router-dom';
import { getSingleInvoices } from 'api/invoiceApiCall';
import "./invoicePay.css"
import {
    Button,
    Spinner
} from 'reactstrap';
import PaymentConfirmationModal from './paymentModal';
import { useTranslation } from '../../../i18n/context';
import { getPaymentInvoice } from "api/invoiceApiCall";
import { getPawaPayPayment } from 'api/invoiceApiCall';
import { convertCurrency } from 'api/invoiceApiCall';


const LoadingSpinner = () => (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100">
        <Spinner
            color="primary"
            style={{ width: '3rem', height: '3rem' }}
        />
        <p className="mt-3 text-primary">loading...</p>
    </div>
);

const getCurrencySymbol = (countryCode) => {
    const currencyMap = {
        'gh': 'GHS',
        'BFA': 'XOF',
        'CIV': 'XOF',
        'SEN': 'XOF',
        'ng': '₦',
        'TGO': 'XOF',
        'RWA': 'FRw',
    };

    return currencyMap[countryCode] || 'GHS';
};



const InvoicePay = () => {
    const { t } = useTranslation();
    const { token } = useParams();
    const [allInvoicesError, setAllInvoicesError] = useState({});
    const [invoice, setInvoice] = useState({});
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [paymentStatus, setPaymentStatus] = useState(false);
    const [logoUrl, setLogoUrl] = useState(null);


    useEffect(() => {
        setIsOpen(false);
    }, []);


    const onPaymentSuccess = () => {
        setIsOpen(false);
        window.location.reload();

    };

    const handleInvoicesCall = async (token) => {
        try {
            setIsLoading(true);
            const [errorInvoicesCall, successInvoiceCall] = await getSingleInvoices({ id: token });


            if (errorInvoicesCall) {
                console.error('Invoice Error:', errorInvoicesCall);
                setAllInvoicesError(errorInvoicesCall);
            } else if (successInvoiceCall) {
                setInvoice(successInvoiceCall);
                setPaymentStatus(successInvoiceCall.paymentStatus);

                if (successInvoiceCall.companyLogo) {
                    const fullLogoUrl = `${process.env.REACT_APP_API_URL}/${successInvoiceCall.companyLogo}`;
                    console.log('Full Logo URL:', fullLogoUrl);
                    console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
                    setLogoUrl(fullLogoUrl);
                } else {
                    console.log('No logo provided in the response');
                }
            } else {
                console.error('No data received from server');
                setAllInvoicesError({ message: 'No data received from the server' });
            }
        } catch (error) {
            console.error('Invoice fetch error:', error);
            setAllInvoicesError({ message: 'An error occurred while fetching the invoice' });
        } finally {
            setIsLoading(false);
        }
    };

    // Always initialize Paystack hook ONCE
    const initializePayment = usePaystackPayment({
        reference: invoice?._id,
        email: invoice?.customer_email,
        amount: invoice?.subtotal ? invoice.subtotal * 100 : 0,
        currency: "GHS",
        publicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
    });

    // const handlePayment = async () => {
    //     try {
    //         if (["ghana", "nigeria"].includes(invoice?.customer_country?.toLowerCase())) {
    //             // Paystack flow
    //             let amount = invoice.subtotal;

    //             if (invoice?.customer_country?.toLowerCase() === 'nigeria') {
    //                 try {
    //                     const convertedData = await convertCurrency(amount, 'NGN', 'GHS');
    //                     amount = convertedData.convertedAmount || amount;
    //                 } catch (error) {
    //                     console.error('Failed to convert amount:', error);
    //                 }
    //             }

    //             const paystackConfig = {
    //                 reference: invoice._id,
    //                 email: invoice.customer_email,
    //                 amount: Math.round(amount * 100),
    //                 currency: "GHS", // Always process in GHS
    //                 publicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
    //             };

    //             const initializePayment = usePaystackPayment(paystackConfig);
    //             initializePayment(
    //                 async (reference) => {
    //                     const [error, paymentVerification] = await getPaymentInvoice(reference);
    //                     if (!error && paymentVerification) {
    //                         setPaymentStatus(true);
    //                         window.location.reload();
    //                     }
    //                 },
    //                 () => {
    //                     console.log("Payment closed");
    //                 }
    //             );
    //         } else {
    //             // PawaPay flow
    //             const invoiceData = await getPawaPayPayment(invoice?._id);
    //             if (
    //                 invoiceData?.status === 200 &&
    //                 invoiceData?.data?.paymentLink?.redirectUrl
    //             ) {
    //                 window.location.href = invoiceData?.data?.paymentLink?.redirectUrl;
    //             }
    //         }
    //     } catch (error) {
    //         console.error("Payment initiation failed:", error);
    //     }
    // };

    const handlePayment = async () => {
        try {
            if (["ghana", "nigeria"].includes(invoice?.customer_country?.toLowerCase())) {
                // Run Paystack
                initializePayment(
                    async (reference) => {
                        const [error, paymentVerification] = await getPaymentInvoice(reference);
                        if (!error && paymentVerification) {
                            setPaymentStatus(true);
                            window.location.reload();
                        }
                    },
                    () => {
                        console.log("Payment popup closed");
                    }
                );
            } else {
                // PawaPay
                const invoiceData = await getPawaPayPayment(invoice?._id);
                if (
                    invoiceData?.status === 200 &&
                    invoiceData?.data?.paymentLink?.redirectUrl
                ) {
                    window.location.href = invoiceData?.data?.paymentLink?.redirectUrl;
                }
            }
        } catch (error) {
            console.error("Payment initiation failed:", error);
        }
    };

    useEffect(() => {
        handleInvoicesCall(token);
    }, [token]);

    const handleClose = () => {
        setIsOpen(false);
        // window.location.reload();
    };

    const currency = getCurrencySymbol(invoice?.country_code);

    if (isLoading) {
        return <LoadingSpinner />;
    }


    if (allInvoicesError.message) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center min-vh-100">
                <div className="text-danger mb-3">
                    <i className="fas fa-exclamation-circle fa-3x"></i>
                </div>
                <h3 className="text-danger">{t('invoice.error_invoice')}</h3>
                <p className="text-muted">{allInvoicesError.message}</p>
                <Button color="primary" onClick={() => handleInvoicesCall(token)}>
                    {t('invoice.retry')}
                </Button>
            </div>
        );
    }


    if (!invoice || !invoice._id) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center min-vh-100">
                <div className="text-warning mb-3">
                    <i className="fas fa-exclamation-triangle fa-3x"></i>
                </div>
                <h3 className="text-warning">{t('invoice.not_found')}</h3>
                <p className="text-muted">{t('invoice.not_be_found')}</p>
            </div>
        );
    }

    return (
        <div id="section-to-print" className="invoice-container">
            <div className="invoice-header">
                <div className="logo-section">

                    <div>
                        {logoUrl ? (
                            <img src={logoUrl} alt="User Logo" style={{ maxWidth: '200px', maxHeight: '100px' }} />
                        ) : (
                            <img src={require("assets/img/brand/aloapp.png")} style={{ maxWidth: '200px', maxHeight: '100px' }} />
                        )}
                    </div>
                </div>
                <div className="invoice-summary">
                    <strong>Total: {currency} {Number(invoice.subtotal).toFixed(2).replace(/\.00$/, '')}</strong>
                    <p className={`payment-status ${paymentStatus ? 'paid' : 'unpaid'}`}>
                        Status: {paymentStatus ? "Paid" : "Unpaid"}
                    </p>

                    <small className="invoice-date">
                        {new Date(invoice.invoice_date).toLocaleDateString()}
                    </small>
                </div>
            </div>

            <div className="invoice-details">
                <div className="customer-info">
                    <h4 className="customer-name">Name: {invoice.customer_name}</h4>
                    <p className="customer-address">Location: {invoice.customer_address}</p>
                </div>
                <div className="product-list">
                    <table className="product-table">
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th className="text-end">Quantity</th>
                                <th className="text-end">Price</th>
                                <th className="text-end">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoice.products.map((product, index) => (
                                <tr key={index}>
                                    <td>{product.product_name}</td>
                                    <td className="text-end">{product.quantity}</td>
                                    <td className="text-end"><small>{currency}</small> {product.price}</td>
                                    <td className="text-end">
                                        <small>{currency}</small> {(product.price * product.quantity).toFixed(2).replace(/\.00$/, '')}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="invoice-summary">
                    {invoice.discount > 0 && (
                        <div className="discount">
                            Discount: - {(invoice.discount * 100).toFixed(0)}%
                        </div>
                    )}
                    <div className="total">
                        <strong>Total: {currency} {Number(invoice.subtotal).toFixed(2).replace(/\.00$/, '')}</strong>
                    </div>
                </div>
            </div>




            {/* Footer */}
            <div className="text-center mt-4 pt-3 border-top">
                <div className="text-center mt-4">
                    <Button
                        color="primary"
                        onClick={handlePayment}
                        style={{ width: "200px" }}
                        disabled={paymentStatus}
                    >
                        {t('invoice.initiate')}
                    </Button>
                </div>
                <small className="text-muted" style={{ fontSize: '10px' }}>
                    ALOAPP Africa
                </small><br></br>
                <small className="text-muted" style={{ fontSize: '10px' }}>
                    {t('invoice.choosing')}
                </small>
            </div>



            {/* Payment Modal */}
            {isOpen && (
                <PaymentConfirmationModal
                    isOpen={isOpen}
                    invoice={invoice}
                    handleClose={handleClose}
                    handlePayment={handlePayment}
                    onPaymentSuccess={onPaymentSuccess}
                />
            )}
        </div>
    );
};

export default InvoicePay;